<template lang="pug">
v-app.about-page
  xo-toolbar
  .about-section.mx-auto(style="max-width: 1600px; width: 100%; color: black")
    .about-banner
      .vertical-border-blue
      .text-container
        p.about-title.font-weight-light The company began as a sideline in 2019 and I finally committed to it full-time in 2022. I did the rounds of corporate jobs while raising five kids with my husband but decided it was time to work on something that would fulfill me and support our lives. I know how scary it is to try something new and I would like to reassure you that we are here for you every step of the way.
      v-spacer
      .d-flex.avatar-container
        .div
          img.mr-1(src="/images/new/about/Team Cielo.jpg")
        .text-container.d-flex.flex-column.justify-content-center.cielo-text
          div
            .text-blue.text-name.h4 Marie Cielo Dayan
            .text-blue.font-weight-light.text-medium.text-position CEO and Founder
            .mt-3.text-medium Cielo is a major stickler for efficiency and order. She likes to look at the big picture and make sure all the cogs fit so her team is following the shortest way to a solution without sacrificing quality. This attention to detail has led to major success in the companies she's worked with, like Hewlett Packard and Accenture, as well as startups like HeyAl and TripClub.

    v-row.testimonial-container
      //- v-col.testimonial-card(cols="12", xl="6", lg="6", md="12", sm="12")
        .testimonial-card-content.d-flex.flex-inline
          .img-thumbnail.mr-2
            img.img-about.cover.mr-1(src="/images/new/about/Team Paul.jpg")
            div(v-if="$vuetify.breakpoint.xsOnly", style="margin-left: 15px")
              .text-blue.text-name.h4 Paul Cañeda
              .text-blue.text-medium.text-position Chief of Operations

          div
            .text-blue.text-name.h4(v-if="$vuetify.breakpoint.smAndUp") Paul Cañeda
            .text-blue.text-medium.text-position(
              v-if="$vuetify.breakpoint.smAndUp"
            ) Chief of Operations
            .mt-1.text-medium Paul has over 12 years of experience in Business Process Outsourcing Operations and bring strong skills of analysis, evaluating processes, and developing improvements- which results in optimum business operations.

      //- v-col.testimonial-card(cols="12", xl="6", lg="6", md="12", sm="12")
        .testimonial-card-content.d-flex.flex-inline
          .img-thumbnail.mr-2
            img.cover.img-about.mr-1(
              src="/images/new/about/Team Ged.jpg",
              style="transform: scale()"
            )
            div(v-if="$vuetify.breakpoint.xsOnly", style="margin-left: 15px")
              .text-blue.text-name.h4 Ged Miraflor
              .text-blue.text-medium.text-position Business Accounts Team Leader

          div
            .text-blue.text-name.h4(v-if="$vuetify.breakpoint.smAndUp") Ged Miraflor
            .text-blue.text-medium.text-position(
              v-if="$vuetify.breakpoint.smAndUp"
            ) Business Accounts Team Leader
            .mt-1.text-medium Ged's strengths shine in processes and procedures, data and analysis. His reports are top notch, and is resourceful and creative when it comes to thinking through operational issues.

      //- v-col.testimonial-card(cols="12", xl="6", lg="6", md="12", sm="12")
        .testimonial-card-content.d-flex.flex-inline
          .img-thumbnail.mr-2
            img.img-about.mr-1(src="/images/new/about/Team Mich.jpg")
            div(v-if="$vuetify.breakpoint.xsOnly", style="margin-left: 15px")
              .text-blue.text-name.h4 Mich Miraflor
              .text-blue.text-medium.text-position Administrative and Development Supervisor
          div
            .text-blue.text-name.h4(v-if="$vuetify.breakpoint.smAndUp") Mich Miraflor
            .text-blue.text-medium.text-position(
              v-if="$vuetify.breakpoint.smAndUp"
            ) Administrative and Development Supervisor
            .mt-1.text-medium In her various roles, Mich has created exceptional experiences both for clients and team members through her thoughtfulness and customer-centricity. She's been an analyst, account manager, trainer, and team lead across various industries.

      v-col.testimonial-card(cols="12", xl="6", lg="6", md="12", sm="12")
        .testimonial-card-content.d-flex.flex-inline
          .img-thumbnail.mr-2
            img.img-about.mr-1(src="/images/new/about/TeamVictor.jpg")
            div(v-if="$vuetify.breakpoint.xsOnly", style="margin-left: 15px")
              .text-blue.text-name.h4 Viktor Hernandez
              .text-blue.text-medium.text-position Business Accounts Team Leader

          div
            .text-blue.text-name.h4(v-if="$vuetify.breakpoint.smAndUp") Viktor Hernandez
            .text-blue.text-medium.text-position(
              v-if="$vuetify.breakpoint.smAndUp"
            ) Business Accounts Team Leader
            .mt-1.text-medium Viktor is our born and bred leader who has literally risen from the ranks in JustAsk!  He is a strong manager who has learned by doing, and is now handling people development and client management.

      //- v-col(cols="12", md="6")
</template>

<script>
export default {
  data() {
    return {
      avatar: [
        "Logo apperPH",
        "Logo Area63",
        "Logo BGA",
        "LogoDigitalMinds",
        "Logo Homeopathy PH",
        "Logo mocean-DkBlue",
        "Logo PixOwl",
        "Logo Sprinkle FIC",
        "LogoTheSecretSauce",
        "LogoVIPTraveler",
        "Logo Wivity",
        "Logo YGG Pinas",
        "Logo YGG",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.text-blue {
  color: #009cb1;
}
.about-page {
  font-family: GothamRounded !important;
}
.h4 {
  margin: 0;
}
.vertical-border-blue {
  border-left: 50px solid #009cb5;
  border-right: 20px solid #7dccad;
  height: 400px;
}

//large
@media (min-width: 1265px) {
  .about-page {
    .about-section {
      margin-top: 60px;
      .about-banner {
        display: flex;
        align-items: center;
        background-color: #f2f2f2;
        padding: 0 50px;
        .cielo-text{
            max-width: 487px !important;
        }
        .text-container {
          max-width: 587px;
          margin: auto;
          padding: 0 18px;
          max-height: 200px;
          .about-title {
            font-size: 1.1rem;
            font-style: italic;
            line-height: 23px;
            font-weight: lighter;
            max-width: 673px;
            margin-left: 20px;
          }
          .subtitle {
            font-weight: bold;
          }

          .text-name {
            font-weight: 550;
            font-size: 1rem;
          }

          .text-position {
            font-size: 0.8rem !important;
          }
          .text-medium {
            font-size: 0.9rem;
            line-height: 20px;
          }
        }
        .avatar-container {
          background-color: #f2f2f2;
          img {
            height: 400px;
            width: 270px;
            object-fit: cover;
          }
          .center {
            object-position: 10% 0;
          }
          .left {
            object-position: 80% 0;
          }
          .mr-1 {
            margin-right: 5px;
          }
        }
      }

      .testimonial-container {
        display: flex;
        justify-content: center;
        margin: 0 auto;
        padding: 10px 30px;
        max-width: 1300px;
        .img-thumbnail {
          display: flex;
          align-items: center;
          background-color: transparent;
          border: none;
        }
        .img-about {
          width: 120px;
          height: 120px;

          object-position: 50%;
          border-radius: 10%;
        }
        .text-details {
          line-height: 20px;
        }

        .testimonial-card {
          border-radius: 10px;
          margin-top: 30px;
          height: 100%;
          position: relative;
          width: 100%;
          padding: 10px 30px;

          .testimonial-card-content {
            align-items: start;
            img {
              height: 113px;
              width: 107px;
            }

            .text-name {
              font-weight: 550;
              font-size: 0.9rem;
            }
            .text-medium {
              font-size: 0.9rem;
              line-height: 20px;
            }

            .text-position {
              padding-bottom: 6px !important;
              font-size: 0.8rem !important;
            }
            // .text-position {
            //     letter-spacing: 0.1rem;
            // }
          }
          .quote {
            position: absolute;
            top: -50px;
          }
          .testimonial-details {
            margin: 0 30px;

            img {
              height: 60px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}
//medium
@media (min-width: 961px) and (max-width: 1263px) {
  .about-page {
    .about-section {
      margin-top: 60px;
      .about-banner {
        display: flex;
        align-items: center;
        background-color: #f2f2f2;
        padding: 0 60px;
        .vertical-border-blue {
          border-left: 40px solid #009cb5;
          border-right: 15px solid #7dccad;
          height: 259px;
        }
        .text-container {
          max-width: 587px;
          margin: auto;
          padding: 0 18px;
          max-height: 200px;
          .about-title {
            font-size: 0.75rem;
            font-style: italic;
            line-height: 18px;
            font-weight: lighter;
            max-width: 536px;
            margin-left: 11px;
          }
          .subtitle {
            font-weight: bold;
          }

          .text-name {
            font-weight: 550;
            font-size: 0.8rem;
          }

          .text-medium {
            font-size: 0.65rem;
            line-height: 16px;
          }
        }
        .avatar-container {
          background-color: #f2f2f2;
          img {
            height: 259px;
            width: 174px;
            object-fit: cover;
            object-position: 10% 10%;
          }
          .center {
            object-position: 10% 0;
          }
          .left {
            object-position: 80% 0;
          }
          .mr-1 {
            margin-right: 5px;
          }
        }
      }

      .testimonial-container {
        display: flex;
        justify-content: center;
        margin: 0 auto;
        padding: 10px 30px;
        max-width: 1135px;
        .img-thumbnail {
          display: flex;
          align-items: center;
          background-color: transparent;
          border: none;
        }
        .img-about {
          width: 120px;
          height: 120px;

          object-position: 50%;
          border-radius: 10%;
        }
        .text-details {
          line-height: 20px;
        }

        .testimonial-card {
          border-radius: 10px;
          margin-top: 30px;
          height: 100%;
          position: relative;
          max-width: 407px;
          padding: 10px 20px;

          .testimonial-card-content {
            align-items: start;
            .img-thumbnail {
              margin-right: 10px;
              img {
                height: 77px;
                width: 76px;
              }
            }
            .text-name {
              font-weight: 550;
              font-size: 0.75rem;
            }
            .text-medium {
              font-size: 0.7rem;
              line-height: 13px;
            }

            // .text-position {
            //     letter-spacing: 0.1rem;
            // }
          }
          .quote {
            position: absolute;
            top: -50px;
          }
          .testimonial-details {
            margin: 0 30px;

            img {
              height: 60px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}
//small
@media (min-width: 601px) and (max-width: 959px) {
  .about-page {
    .about-section {
      margin-top: 60px;
      .about-banner {
        display: flex;
        align-items: center;
        background-color: #f2f2f2;
        padding: 0 35px;
        .vertical-border-blue {
          border-left: 40px solid #009cb5;
          border-right: 15px solid #7dccad;
          height: 201px;
        }
        .text-container {
          max-width: 587px;
          margin: auto;
          padding: 0 11px;
          max-height: 200px;
          .about-title {
            font-size: 0.65rem;
            font-style: italic;
            line-height: 14px;
            font-weight: lighter;
            max-width: 536px;
            margin-left: 11px;
          }
          .subtitle {
            font-weight: bold;
          }

          .text-name {
            font-weight: 550;
            font-size: 0.75rem;
          }

          .text-medium {
            font-size: 0.6rem;
            line-height: 13px;
          }
        }
        .avatar-container {
          background-color: #f2f2f2;
          img {
            height: 201px;
            width: 141px;
            object-fit: cover;
            object-position: 10% 10%;
          }
          .center {
            object-position: 10% 0;
          }
          .left {
            object-position: 80% 0;
          }
          .mr-1 {
            margin-right: 5px;
          }
        }
      }

      .testimonial-container {
        display: flex;
        justify-content: center;
        margin: 0 auto;
        padding: 10px 30px;
        max-width: 1135px;
        .img-thumbnail {
          display: flex;
          align-items: center;
          background-color: transparent;
          border: none;
        }
        .img-about {
          width: 120px;
          height: 120px;

          object-position: 50%;
          border-radius: 10%;
        }
        .text-details {
          line-height: 20px;
        }

        .testimonial-card {
          border-radius: 10px;
          margin-top: 30px;
          height: 100%;
          position: relative;
          max-width: 319px;
          padding: 10px 20px;

          .testimonial-card-content {
            align-items: start;
            .img-thumbnail {
              margin-right: 10px;
              img {
                height: 71px;
                width: 66px;
              }
            }
            .text-name {
              font-weight: 550;
              font-size: 0.65rem;
            }
            .text-medium {
              font-size: 0.55rem;
              line-height: 11px;
            }

            // .text-position {
            //     letter-spacing: 0.1rem;
            // }
          }
          .quote {
            position: absolute;
            top: -50px;
          }
          .testimonial-details {
            margin: 0 30px;

            img {
              height: 60px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
}
//xs
@media (min-width: 320px) and(max-width: 599px) {
  .about-page {
    .about-section {
      .about-banner {
        padding: 0;
        display: flex;
        flex-direction: column;
        .vertical-border-blue {
          background-color: #009cb5;
          height: 30px;
          width: 100%;
        }
        .text-container {
          max-width: 800px;
          margin: 45px auto;
          font-size: 1.1rem;
          padding: 0 20px;

          .about-title {
            font-size: 1rem;
            font-style: italic;
            line-height: 24px;
            font-weight: lighter;
            max-width: 536px;
            margin-left: 11px;
            margin-bottom: 0;
          }
          .subtitle {
            font-weight: bold;
          }

          .text-name {
            font-weight: 550;
            font-size: 1.1rem;
          }

          .text-medium {
            font-size: 1rem;
            line-height: 24px;
          }
        }
        .avatar-container {
          display: flex;
          flex-direction: column;
          img {
            height: 452px;
            width: 100%;
            object-fit: cover;
            object-position: 5% 5%;
          }
          .text-container {
            margin: 0 10px;
            max-width: 900px;
            margin: 45px auto;
            font-size: 1.5rem;
            .text-blue {
              font-size: 1.5rem;
            }
            .about-title {
              font-size: 1.3rem;
            }
          }
        }
      }

      .testimonial-container {
        padding: 10px;
        .testimonial-card-content {
          display: flex;
          flex-direction: column;
        }

        .img-thumbnail {
          display: flex;
          flex-direction: inline;
          align-items: center;
          background-color: transparent;
          border: none;

          .text-name {
            font-size: 1rem;
          }
        }
        .img-about {
          width: 84px;
          height: 85px;
          object-position: 50%;
          border-radius: 10%;
          border: none;
        }
        .text-medium {
          font-size: 1rem;
          line-height: 24px;
        }
        .testimonial-card {
          margin: 20px 10px;
          max-width: 750px;
        }
      }
    }
  }
}
</style>
